import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { ActivityListService } from 'src/app/shared/services/activity-list.service';
import { ActivityListModel } from 'src/app/shared/models/activity-list.model';
import { firstValueFrom } from 'rxjs';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PriorityModel } from 'src/app/shared/models/priority.model';
import { RegionsModel } from 'src/app/shared/models/region.model';
import { ResponsibleModel } from 'src/app/shared/models/responsible.model';
import { ClassificationModel } from 'src/app/shared/models/classification.model';
import { StatusModel } from 'src/app/shared/models/status.model';

interface CardItem {
  id: number;
  date: string,
  status: string,
  description: string;
}

@Component({
  selector: 'app-activity-list',
  templateUrl: './activity-list.component.html',
  styleUrls: ['./activity-list.component.scss'],
  imports: [
    TegelModule,
    CommonModule,
    MatPaginatorModule,
    MatCardModule,
    MatSnackBarModule,
    ReactiveFormsModule
  ],
})
export class ActivityListComponent implements OnInit {

  @ViewChild(ModalComponent) modalComponent!: ModalComponent;

  form!: FormGroup;

  activity!: ActivityListModel;
  prioritys: PriorityModel[] = [];
  regions: RegionsModel [] = [];
  responsibles: ResponsibleModel [] = [];
  classifications: ClassificationModel [] = [];
  status: StatusModel [] = [];

  activityList: ActivityListModel [] = [];

  constructor(private service: ActivityListService, private snackBar: MatSnackBar, private fb: FormBuilder) { }

  totalItems = 0;
  pageSize = 5;
  pagedItems: CardItem[] = [];
  showDetails = false

  hideToasts: boolean = false;

  mockData: CardItem[] = Array.from({ length: 20 }).map((_, i) => ({
    id: i + 1,
    date: '02/10/2024 16:10',
    status: 'DROP',
    description: `Descrição do item ${i + 1}`,
  }));

  ngOnInit() {
    this.getAll()
    
    this.activity = this.getNewActivity();
    this.loadPrioritys();
    this.loadRegions();
    this.loadResponsibles();
    this.loadClassifications();
    this.loadStatus();

    this.form = this.fb.group({
      activityName: ['', [Validators.required]],
      chassisNumber: ['', [Validators.required]],
      responsible: ['', Validators.required],
      notes: [],
      priority: ['', Validators.required],
      region: ['', Validators.required],
      targetDate: ['', Validators.required],
      classification: ['', Validators.required],
      closedDate: ['', Validators.required],
      lastUpdateDate: ['', Validators.required],
      department: ['', Validators.required],
      assignedBy: ['', Validators.required],
      status: ['', Validators.required],
    });
  }

  openModal() {
    this.modalComponent.open();
  }

  setPage(pageIndex: number, pageSize: number) {
    const start = pageIndex * pageSize;
    const end = start + pageSize;
  }

  onPageChange(event: PageEvent) {
    this.setPage(event.pageIndex, event.pageSize);
  }

  show() {
    this.activity = this.getNewActivity()
    this.showDetails = this.showDetails ? false : true;
  }

  showId(id: number) {
    if (id) {
      const foundActivity = this.activityList.find(x => x.id === id);
  
      if (foundActivity) {
        this.activity = foundActivity;
        this.showDetails = !this.showDetails;
      }
    }
  }

  async getAll(){
    const result = await firstValueFrom(this.service.getAllActivity());

    this.activityList = result;
    this.totalItems = this.activityList.length;
    this.setPage(0, this.pageSize);

    console.log(this.activityList)
  }

  async save() {
    try {
      console.log('Salvar', this.form.valid)
      if (this.form.valid) {
        const result = await firstValueFrom(this.service.createActivity(this.activity));
        this.showToast('The operation was completed successfully.');
        this.resetForm();
        this.show()
        this.getAll()
      }

      if (this.form.invalid) {
        this.form.markAllAsTouched();
        return;
      }
    } catch (error) {
      this.showToast('An error occurred. Please try again.');
    }
  }

  toggleToasts(){
    this.hideToasts = !this.hideToasts
  }

  async showToast(message: string) {
    this.snackBar.open(message, 'X', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'app-notification-success',
    });
  }

  getNewActivity() : ActivityListModel{
    return {
      id: null,
      activityName: null,
      chassisNumber: null,
      idPriority: null,
      idResponsible: null,
      idRegion: null,
      targetDate: null,
      idClassification: null,
      notes: null,
      closedDate: null,
      lastUpdateDate: null,
      department: null,
      assignedBy: null,
      status: null
    };
  }

  resetForm(){
    this.activity = this.getNewActivity()
  }

  loadPrioritys() {
    this.prioritys = [
      {
        id: '1',
        priority: 'Low'
      },
      {
        id: '2',
        priority: 'Medium'
      },
      {
        id: '3',
        priority: 'High'
      },
    ]
  }

  loadRegions() {
    this.regions = [
      {
        id: '1',
        region: 'India'
      },
      {
        id: '2',
        region: 'Brazil'
      },
      {
        id: '3',
        region: 'Russia'
      },
    ]
  }

  loadStatus() {
    this.status = [
      {
        id: '1',
        status: 'INFO'
      },
      {
        id: '2',
        status: 'OPEN'
      },
      {
        id: '3',
        status: 'CLOSE'
      },
    ]
  }

  loadResponsibles() {
    this.responsibles = [
      {
        id: '1',
        responsible: 'Pedro'
      },
      {
        id: '2',
        responsible: 'Eliabel'
      },
    ]
  }

  loadClassifications() {
    this.classifications = [
      {
        id: '1',
        classification: 'ECO'
      },
    ]
  }
}